import { User } from 'src/app/shared/models/user';
import { ParentalConsentGrid } from './parental-consent-grid-data-model';

export class ConsentRequestModel {
    consentSk!: string;
    consentType!: number;
    sentDateTime!: string;
    personSk!: string;
    outcome!: string;
    validUntilDate!: string;
    validFromDate!: string;
    lastModuser!: string;
    lastModTs!: string;
    parentSk!: string;
    studentSk!: string;
    nycId!: string;
    writtenLanguage: string | number;
    status!: number;
    formJSON:string;
  
    constructor(row: ParentalConsentGrid,user:User) {
      const now: string = new Date().toISOString();
      this.consentType = 107;
      this.sentDateTime = now;
      this.personSk = user.personSk;
      this.outcome = null;
      this.validFromDate = now;
      this.validUntilDate = now;
      this.lastModuser = '';
      this.lastModTs = now;
      this.parentSk = row.iepSk;
      this.studentSk = row.studentSk;
      this.nycId = row.studentNycId;
    this.writtenLanguage= row.writtenLanguage;
      this.status = 1;
      this.formJSON = JSON.stringify({
        consentType: this.consentType,
        sentDateTime: this.sentDateTime,
        personSk: this.personSk,
        outcome: this.outcome,
        validFromDate: this.validFromDate,
        validUntilDate: this.validUntilDate,
        lastModuser: this.lastModuser,
        lastModTs: this.lastModTs,
        parentSk: this.parentSk,
        studentSk: this.studentSk,
        nycId: this.nycId,
        writtenLanguage: this.writtenLanguage,
        status: this.status,
        
      });
    }
  }
  